import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { isEmpty, formatMobilePhone } from '@jjj/components';
import { logger } from './logger';

export const isMobilePhone = (value: string, country_alpha_2_code: CountryCode) => {
  let parsedPhoneNumber;

  if (isEmpty(value)) {
    return true;
  }

  try {
    parsedPhoneNumber = parsePhoneNumberFromString(formatMobilePhone(value), country_alpha_2_code);
  } catch (error) {
    logger.log(error);
  }

  return !!parsedPhoneNumber?.isValid();
};
